// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_juS","cls2":"VideoReportModal-cls2_MN1 VideoReportModal-cls1_juS"};